var exports = {
  "cn": "lastEditInfoContainer__6mCcpP",
  "F": "editorLogin__g5cPQJ",
  "me": "separator__2nWPZV",
};

module.exports = exports;
